var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnallocated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21071_259808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_21071_259808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 12.7004L9.5499 15.1504C9.45824 15.2421 9.34157 15.2879 9.1999 15.2879C9.05824 15.2879 8.94157 15.2421 8.8499 15.1504C8.75824 15.0587 8.7124 14.9421 8.7124 14.8004C8.7124 14.6587 8.75824 14.5421 8.8499 14.4504L11.2999 12.0004L8.8499 9.55039C8.75824 9.45872 8.7124 9.34206 8.7124 9.20039C8.7124 9.05872 8.75824 8.94206 8.8499 8.85039C8.94157 8.75872 9.05824 8.71289 9.1999 8.71289C9.34157 8.71289 9.45824 8.75872 9.5499 8.85039L11.9999 11.3004L14.4499 8.85039C14.5416 8.75872 14.6582 8.71289 14.7999 8.71289C14.9416 8.71289 15.0582 8.75872 15.1499 8.85039C15.2416 8.94206 15.2874 9.05872 15.2874 9.20039C15.2874 9.34206 15.2416 9.45872 15.1499 9.55039L12.6999 12.0004L15.1499 14.4504C15.2416 14.5421 15.2874 14.6587 15.2874 14.8004C15.2874 14.9421 15.2416 15.0587 15.1499 15.1504C15.0582 15.2421 14.9416 15.2879 14.7999 15.2879C14.6582 15.2879 14.5416 15.2421 14.4499 15.1504L11.9999 12.7004Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21071_259808",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C70D18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21071_259808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnallocated);
export default __webpack_public_path__ + "static/media/unallocated.e5bca5a00d1b0fb746c8935462ad929e.svg";
export { ForwardRef as ReactComponent };